const $ = jQuery;

const videoPlayHook = (playHookCallBack) => {
	let videoEl = $(".elementor-video")[0];
	let hookCalled = false;
	videoEl.addEventListener('timeupdate', function (e) {
		let currentProgress = Math.round((videoEl.currentTime / videoEl.duration) * 100);
		if (currentProgress >= 65 && !hookCalled) {
			playHookCallBack();
			hookCalled = true;
		}
	}, false);
}

export default videoPlayHook;
